export default __webpack_public_path__ + "static/media/generated.a0768d68.png";